import axios from "axios";
import {
  Consent,
  ConsentWithLabel,
  Label,
  Preferences,
  PreferencesOption
} from "../common/GeneralClasses";
import QueryParameters from "./QueryParameters";

function getApiBaseUrl(): string {
  const hostname = window.location.hostname;
  if (hostname.includes("uat-preferences.unileversolutions.com")) return "https://uat-api-preferences.unileversolutions.com";
  if (hostname.includes("preferences.unileversolutions.com"))  return "https://api-preferences.unileversolutions.com";
  // Local dev fallback
  return process.env.REACT_APP_API_URL || "http://localhost:8080";
}

const BASE_URL = getApiBaseUrl();

const HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json"
};
interface Status {
  status: boolean;
}
class View {
  constructor(public labels: Label[]) {}
}
class ViewWithConsents extends View {
  constructor(
    public labels: Label[],
    public consentsWithLabel: ConsentWithLabel[],
    public error: boolean
  ) {
    super(labels);
  }
}
class ViewWithPreferences extends View {
  constructor(
    public labels: Label[],
    public preferences: PreferencesOption[],
    public error: boolean
  ) {
    super(labels);
  }
}

function passThroughMockTestParam(queryParameters: QueryParameters) {
  return queryParameters.getMockTest() ? { mockTest: true } : {};
}

export async function getBulkLabels(queryParameters: QueryParameters): Promise<View> {
  const response = await axios.get(BASE_URL + "/bulkLabels", {
    params: {
      market: queryParameters.getMarket(),
      lang: queryParameters.getLang(),
      brand: queryParameters.getBrand(),
      ...passThroughMockTestParam(queryParameters)
    }
  });
  return response.data;
}

export async function getMultiselectLabels(
  queryParameters: QueryParameters
): Promise<ViewWithConsents> {
  const params = {
    market: queryParameters.getMarket(),
    lang: queryParameters.getLang(),
    brand: queryParameters.getBrand(),
    eulid: queryParameters.getUser(),
    ...passThroughMockTestParam(queryParameters)
  };

  const response = await axios.get(BASE_URL + "/multiselectLabels", {
    params: params
  });
  return response.data;
}

export async function getPreferences(
  queryParameters: QueryParameters
): Promise<ViewWithPreferences> {
  const params = {
    market: queryParameters.getMarket(),
    lang: queryParameters.getLang(),
    brand: queryParameters.getBrand(),
    eulid: queryParameters.getUser(),
    ...passThroughMockTestParam(queryParameters)
  };

  const response = await axios.get(BASE_URL + "/getPreferences", {
    params: params
  });
  return response.data;
}

export async function sendUnsubscribeRequest(queryParameters: QueryParameters): Promise<Status> {
  const body = {
    market: queryParameters.getMarket(),
    lang: queryParameters.getLang(),
    brand: queryParameters.getBrand(),
    userId: queryParameters.getUser(),
    skipErrorHandling: true
  };
  const response = await axios.post(BASE_URL + "/unsubscribe", body, {
    headers: HEADERS,
    params: passThroughMockTestParam(queryParameters)
  });
  return response.data;
}

export async function sendOptOutRequest(
  queryParameters: QueryParameters,
  consents: Consent[]
): Promise<Status> {
  const body = {
    market: queryParameters.getMarket(),
    lang: queryParameters.getLang(),
    brand: queryParameters.getBrand(),
    userId: queryParameters.getUser(),
    consents: consents,
    skipErrorHandling: true
  };
  const response = await axios.post(BASE_URL + "/optout", body, {
    headers: HEADERS,
    params: passThroughMockTestParam(queryParameters)
  });
  return response.data;
}

export async function sendPreferencesRequest(
  queryParameters: QueryParameters,
  preferences: Preferences[]
): Promise<Status> {
  const body = {
    eulid: queryParameters.getUser(),
    brand: queryParameters.getBrand(),
    market: queryParameters.getMarket(),
    preferences: preferences,
    skipErrorHandling: true
  };
  const response = await axios.post(BASE_URL + "/updatePreferences", body, {
    headers: HEADERS,
    params: passThroughMockTestParam(queryParameters)
  });
  return response.data;
}
